export const resumeLink = "https://drive.google.com/file/d/1lrGhuwro6X3AARxTIFcqo8pLcdsw3gah/view?usp=sharing";


export const youtubeLink = "https://www.youtube.com/channel/UCH9Cu7oVHT_GcAdVsXiWNtg";
export const githubUsername = 'pranavmalwatkar';
export const githubLink = "https://github.com/pranavmalwatkar";
export const linkedinLink = "https://www.linkedin.com/in/pranav-malwatkar-9834b1239/";
export const mailtoLink = "mailto:malwatkarpranav@gmail.com";

export const leetCodeUserName = 'Pranav_Raju_Malwatkar'; 
export const leetcodelink = "https://leetcode.com/graphql";